function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from '@dtsl/css-close/dist/index.module.css';
import Cross from '@dtsl/icons/dist/icons/react/X';

// eslint-disable-next-line react/display-name
const Close = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    size = [''],
    disabled = false,
    className = '',
    ariaLabel = 'close button',
    dataTestId = 'sib-close-testId',
    ...props
  } = _ref;
  const closeBtnClasses = classNames({
    [styles['sib-close']]: true,
    [styles['sib-btn']]: true,
    [styles[`sib-btn_size--${size}`]]: !!size,
    [styles['sib-btn_icon-stand-alone']]: true,
    [className]: !!className
  });
  return /*#__PURE__*/React.createElement("button", _extends({
    ref: ref,
    type: "button",
    className: closeBtnClasses,
    "data-testid": dataTestId,
    "aria-label": ariaLabel,
    disabled: disabled,
    "aria-disabled": disabled || null
  }, props), /*#__PURE__*/React.createElement(Cross, {
    "aria-hidden": "true"
  }));
});
Close.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOf(['', 'small']),
  dataTestId: PropTypes.string,
  disabled: PropTypes.bool,
  ariaLabel: PropTypes.string
};
export default Close;